import { debounce, pxToRem, remToPx } from "../inc/helpers";

const [gap200, gap400] = Array.from({ length: 2 }).map((_, i) =>
  remToPx(`--gap-${(i + 1) * 200}`),
);

export default class Swipers {
  init() {
    this.initSwiperGalleries();
    this.initSwiperPosts();
    this.initSwiperFade();
    this.initSwiperProductCard();
  }

  initSwiperFade() {
    const swipers = document.querySelectorAll(".js-swiper-fade");
    swipers.forEach((swiper) => {
      const _swiper = new Swiper(swiper, {
        slidesPerView: 1,
        spaceBetween: gap200,
        effect: "fade",
        centeredSlides: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
          },
          992: {
            slidesPerView: 1,
            spaceBetween: gap400,
          },
        },
        keyboard: {
          enabled: true,
        },
      });
    });
  }

  initSwiperGalleries() {
    const swipers = document.querySelectorAll(".js-swiper-gallery");
    swipers.forEach((swiper) => {
      const [l, m, s] = ["l", "m", "s"].map((el) =>
        parseInt(swiper.style.getPropertyValue(`--n-${el}`)),
      );

      const _swiper = new Swiper(swiper, {
        slidesPerView: isNaN(s) ? 1 : s,
        spaceBetween: gap200,
        navigation: {
          nextEl: swiper.querySelector(".swiper-button-next"),
          prevEl: swiper.querySelector(".swiper-button-prev"),
        },
        keyboard: {
          enabled: true,
        },
        breakpoints: {
          768: {
            slidesPerView: isNaN(m) ? 1 : m,
          },
          992: {
            slidesPerView: isNaN(l) ? 1 : l,
          },
        },
      });
    });
  }

  initSwiperPosts() {
    const swipers = document.querySelectorAll(".js-swiper-posts");
    swipers.forEach((swiper) => {
      const _swiper = new Swiper(swiper, {
        slidesPerView: 1.1,
        spaceBetween: gap200,
        navigation: {
          nextEl: swiper.querySelector(".swiper-button-next"),
          prevEl: swiper.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          768: {
            slidesPerView: 2.125,
          },
          992: {
            slidesPerView: 2.25,
            spaceBetween: gap400,
          },
        },
        keyboard: {
          enabled: true,
        },
      });
    });
  }

  initSwiperProductCard() {
    const breakpoint = pxToRem(768);
    const swipers = document.querySelectorAll(".js-swiper-product-cards");
    let _swipers = [];
    const onResize = () => {
      swipers.forEach((s) => {
        const parent = s.parentNode;
        const sep = parent?.querySelector(".separator");
        sep?.style.removeProperty("--sep-w");
        sep?.style.removeProperty("--sep-t");
      });
      _swipers.forEach((_s) => {
        _s.destroy();
        _s = undefined;
      });
      _swipers = [];

      if (!window.matchMedia(`(min-width: ${breakpoint}rem)`).matches) {
        swipers.forEach((s) => {
          const parent = s.parentNode;
          const sep = parent?.querySelector(".separator");
          const _swiper = new Swiper(s, {
            slidesPerView: 1,
            spaceBetween: gap200,
            pagination: {
              el: s.querySelector(".swiper-pagination-product-cards"),
            },
          });
          const w = window.innerWidth * 2;
          sep?.style.setProperty("--sep-w", `${w}px`);
          _swiper.on("progress", (_s, progress) => {
            const x = (progress * w) / 2;
            sep?.style.setProperty("--sep-t", `${-x}px`);
          });
          _swipers.push(_swiper);
        });
      }
    };

    window.addEventListener("resize", onResize);
    onResize();
  }
}
